module.exports = __webpack_public_path__ + "media/images/icons/filled/medicine-box-6b52ed07e7d3104dfb6d6a189aaac5f0.svg";